import type {Unsubscribe} from "./createEvent";

export type EventLike<T = unknown> = {
    on(listener: (payload: T) => void): Unsubscribe;
};

// Достает тип payload из события (для объединения событий получится объединение payload)
export type EventPayload<E> = E extends EventLike<infer P> ? P : never;

export const subscribeMany = <E extends EventLike>(
    events: readonly E[],
    listener: (payload: EventPayload<E>) => void,
): Unsubscribe => {
    const unsubscribers = events.map(event =>
        event.on(listener as (payload: unknown) => void)
    );

    return () => {
        unsubscribers.forEach(unsubscribe => unsubscribe());
    };
};
//
// export type EventLike = {
//     on(listener: (...args: unknown[]) => void): () => void;
// };
//
// export const subscribeMany = (
//     events: EventLike[],
//     listener: () => void,
// ) => {
//     const unSubscribers = events.map(event => event.on(listener));
//
//     return () => {
//         unSubscribers.forEach(unsubscribe => unsubscribe());
//     };
// };
